import React, { FC, useCallback } from 'react';

import { DueInTrigger as DueInTriggerType } from 'src/actions/rules/trigger';
import DueInSection from '../shared/DueInSection';

type DueInTriggerProps = {
  trigger: DueInTriggerType;
  onChange: Function;
};

const DueInTrigger: FC<DueInTriggerProps> = ({ trigger, onChange }) => {
  const onDueStatusChange = useCallback(
    status => {
      const dueValue = trigger.value;
      dueValue.setStatus(status);
      trigger.setValue(dueValue);
      onChange(trigger);
    },
    [trigger, onChange]
  );

  const onMinutesChange = useCallback(
    evt => {
      const minutes = parseInt(evt.target.value);
      if (isNaN(minutes) || minutes <= 0) return;

      const dueValue = trigger.value;
      dueValue.setMinutes(minutes);
      trigger.setValue(dueValue);
      onChange(trigger);
    },
    [trigger, onChange]
  );

  const value = trigger.value;

  return <DueInSection value={value} onDueStatusChange={onDueStatusChange} onMinutesChange={onMinutesChange} />;
};

export default DueInTrigger;
